import { Link } from "react-router-dom";
import { 
  Heart, 
  FirstAid, 
  Baby, 
  Brain, 
  Bone, 
  Users 
} from "@phosphor-icons/react";

const SPECIALTY_ICONS = {
  cardiology: Heart,
  dermatology: FirstAid,
  pediatrics: Baby,
  psychiatry: Brain,
  orthopedics: Bone,
  "family-medicine": Users,
};

const SPECIALTY_COLORS = {
  cardiology: "text-rose-500 group-hover:text-rose-600",
  dermatology: "text-amber-500 group-hover:text-amber-600",
  pediatrics: "text-sky-500 group-hover:text-sky-600",
  psychiatry: "text-indigo-500 group-hover:text-indigo-600",
  orthopedics: "text-emerald-500 group-hover:text-emerald-600",
  "family-medicine": "text-blue-500 group-hover:text-blue-600",
};

const SPECIALTY_BG = {
  cardiology: "bg-rose-50 group-hover:bg-rose-100",
  dermatology: "bg-amber-50 group-hover:bg-amber-100",
  pediatrics: "bg-sky-50 group-hover:bg-sky-100",
  psychiatry: "bg-indigo-50 group-hover:bg-indigo-100",
  orthopedics: "bg-emerald-50 group-hover:bg-emerald-100",
  "family-medicine": "bg-blue-50 group-hover:bg-blue-100",
};

const SpecialtyCard = ({ specialty, onClick }) => {
  const slug = specialty.slug || specialty.name.toLowerCase().replace(/\s+/g, '-');
  const Icon = SPECIALTY_ICONS[slug] || Heart;
  const colorClass = SPECIALTY_COLORS[slug] || "text-slate-500";
  const bgClass = SPECIALTY_BG[slug] || "bg-slate-50";

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(specialty);
    }
  };

  return (
    <Link
      to={`/specialty/${slug}`}
      onClick={handleClick}
      className="specialty-card bg-white border border-slate-100 rounded-lg p-6 flex flex-col items-center justify-center text-center gap-4 group"
      data-testid={`specialty-card-${slug}`}
    >
      <div className={`w-16 h-16 rounded-full ${bgClass} flex items-center justify-center transition-colors`}>
        <Icon className={`w-8 h-8 specialty-icon ${colorClass} transition-colors`} weight="duotone" />
      </div>
      <span className="font-display font-semibold text-slate-800 group-hover:text-navy transition-colors">
        {specialty.name}
      </span>
    </Link>
  );
};

export default SpecialtyCard;
